(function (Drupal, once) {
    'use strict';

    // ✅ Toggle: auf true stellen, wenn du debuggen willst
    const DEBUG = false;

    // Optional: kleines Badge im DOM anzeigen (oben rechts im Formular)
    const DEBUG_BADGE = true;

    function log(...args) {
        if (!DEBUG) return;
        // Gruppierbar und eindeutig filterbar in der Konsole
        console.log('[webform-image-select-autonext]', ...args);
    }

    function warn(...args) {
        if (!DEBUG) return;
        console.warn('[webform-image-select-autonext]', ...args);
    }

    function addBadge(form, text) {
        if (!DEBUG || !DEBUG_BADGE || !form) return;

        // pro Form nur einmal
        if (form.querySelector('[data-webform-autonext-badge="1"]')) return;

        const badge = document.createElement('div');
        badge.setAttribute('data-webform-autonext-badge', '1');
        badge.textContent = text;

        // Minimal-invasiv, ohne CSS-Datei
        badge.style.position = 'absolute';
        badge.style.top = '8px';
        badge.style.right = '8px';
        badge.style.zIndex = '9999';
        badge.style.padding = '4px 8px';
        badge.style.fontSize = '12px';
        badge.style.borderRadius = '999px';
        badge.style.background = 'rgba(0,0,0,.7)';
        badge.style.color = '#fff';

        // Formular braucht Positioning-Kontext
        const currentPos = window.getComputedStyle(form).position;
        if (currentPos === 'static') {
        form.style.position = 'relative';
        }

        form.appendChild(badge);
    }

    function triggerNext(form) {
        const nextBtn =
        form.querySelector('input.webform-button--next.js-form-submit, button.webform-button--next.js-form-submit') ||
        form.querySelector('input[id^="edit-actions-wizard-next"], button[id^="edit-actions-wizard-next"]');

        if (!nextBtn) {
            warn('Kein Next-Button gefunden im Form', form);
            return;
        }

        if (nextBtn.disabled || nextBtn.getAttribute('aria-disabled') === 'true') {
            warn('Next-Button ist disabled/aria-disabled', nextBtn);
            return;
        }

        if (form.dataset.webformAutoNextBusy === '1') {
            log('Busy-Guard aktiv → kein weiterer Next-Klick', form);
            return;
        }

        form.dataset.webformAutoNextBusy = '1';

        log('Trigger NEXT click', {
            formId: form.getAttribute('id'),
            nextId: nextBtn.getAttribute('id'),
            nextValue: nextBtn.value || nextBtn.textContent,
        });

        nextBtn.click();

        window.setTimeout(() => {
            form.dataset.webformAutoNextBusy = '0';
            log('Busy-Guard zurückgesetzt');
        }, 1500);
    }

    Drupal.behaviors.webformImageSelectAutoNext = {
        attach(context) {
            log('Behavior attach()', {
                context: context === document ? 'document' : context,
            });

            // Find forms in context and badge them (zeigt sofort: JS läuft + attach wurde getriggert)
            if (DEBUG_BADGE) {
                const forms = once(
                    'webform-image-select-autonext-badge',
                    'form.webform-submission-form',
                    context
                );
                forms.forEach((form) => addBadge(form, 'AutoNext: aktiv'));
                log('Badge forms gefunden:', forms.length);
            }

            // Thumbnails im aktuellen context (Ajax replace!)
            const thumbnails = once(
                'webform-image-select-autonext',
                '.webform-image-select + ul.image_picker_selector .thumbnail',
                context
            );

            log('Thumbnails gefunden:', thumbnails.length);

            thumbnails.forEach((thumb, idx) => {
                const form = thumb.closest('form');

                if (!form) {
                    warn('Thumbnail ohne Form gefunden', thumb);
                    return;
                }

                if (!form.classList.contains('webform-submission-form')) {
                    warn('Form ist keine webform-submission-form → skip', form);
                    return;
                }

                // Zusätzliche Debug-Info zur Zuordnung
                const title = thumb.getAttribute('title') || thumb.textContent?.trim() || `(thumb #${idx})`;
                log('Bind events auf thumbnail:', title);

                thumb.addEventListener('click', () => {
                    log('CLICK auf thumbnail:', title, thumb);

                    window.setTimeout(() => {
                        const select = form.querySelector('select.webform-image-select');

                        if (!select) {
                            warn('Kein select.webform-image-select im Form gefunden');
                            return;
                        }

                        // ⛔ NEU: Wenn multiple aktiv → niemals AutoNext
                        if (select.hasAttribute('multiple')) {
                            log('Multiple-Select erkannt → AutoNext deaktiviert');
                            return;
                        }

                        log('Aktueller select value:', select.name, select.value);

                        triggerNext(form);
                    }, 0);
                });

                thumb.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        log('KEYDOWN auf thumbnail:', title, 'key=', e.key);

                        window.setTimeout(() => {
                            const select = form.querySelector('select.webform-image-select');
                            if (!select) return;

                            if (select.hasAttribute('multiple')) {
                                log('Multiple-Select erkannt (keydown) → AutoNext deaktiviert');
                                return;
                            }

                            log('Aktueller select value (keydown):', select.name, select.value);
                            triggerNext(form);
                        }, 0);
                    }
                });
            });
        },
    };

    // Sofort sichtbar: Script wurde geladen (auch bevor attach läuft)
    log('Script geladen ✅');
})(Drupal, once);